import { useState, type ReactNode } from "react";

export function CollapsibleSection({ title, summary, children, defaultOpen = true, className = "" }: {
  title: string;
  summary?: string;
  children: ReactNode;
  defaultOpen?: boolean;
  className?: string;
}) {
  const [open, setOpen] = useState(defaultOpen);
  return <section className={`collapsible-section ${open ? "is-open" : ""} ${className}`.trim()}>
    <button className="collapsible-section__trigger" type="button" aria-expanded={open} onClick={() => setOpen((current) => !current)}>
      <span><strong>{title}</strong>{summary && <small>{summary}</small>}</span>
      <span className="collapsible-section__mark" aria-hidden="true">{open ? "−" : "+"}</span>
    </button>
    <div className="collapsible-section__body" aria-hidden={!open} inert={!open}>
      <div className="collapsible-section__content">{children}</div>
    </div>
  </section>;
}
